import PropTypes from 'prop-types';

export const FormConfigPropsShape = {
  id: PropTypes.string, // machine id
  view: PropTypes.func,
  viewProps: PropTypes.shape({}),
  repository: PropTypes.func,
  repositoryProps: PropTypes.shape({}),
  machineOptions: PropTypes.shape({
    machineService: PropTypes.shape({}), // register by Parent Machine

    initialState: PropTypes.string, // initial state
    context: PropTypes.shape({}), // initial context
    guards: PropTypes.shape({}), // guards: needsLoading, needsSaving, needsConfirming
    actions: PropTypes.shape({}), // actions: onLoading, onSaving etc.
    observer: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
  }),
  render: PropTypes.func,
};
